import config from './config.json';
import { MenuItem } from '../types/menuItem';

const { home, expertise, watBiedenWijJou, vacatures } = config.pages;

export const menuItems: MenuItem[] = [home, expertise, watBiedenWijJou, vacatures];
